import React from 'react'

// components
import Typography from '@mui/material/Typography'

const Paragraph = ({ children }) => {
  return (
    <Typography py={1} variant='body1'>
      {children}
    </Typography>
  )
}

export default Paragraph
